import { gql } from '@apollo/client';

export const DELETE_OBJECTIVE_CRITERIA_MUTATION = gql`
    mutation DeleteObjectiveCriterion($input: DeleteObjectiveCriterionInput!) {
        result: deleteObjectiveCriterion(input: $input) {
            affectedRows
        }
    } 
`;

